var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main-header'),_c('b-container',[_c('b-row',[_c('b-col',{staticClass:"nav-col",attrs:{"md":"12","xl":"3"}},[_c('main-nav')],1),_c('b-col',{staticClass:"mt-4"},[_vm._t("default")],2)],1)],1),_c('main-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }